"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mondialRelayShippingMethods = exports.colissimoShippingMethods = void 0;
var colissimoShippingMethods = exports.colissimoShippingMethods = [{
  id: 371,
  name: 'Colissimo Home 0-0.25kg',
  minWeight: 0,
  maxWeight: 0.250,
  FR: 8.83
}, {
  id: 366,
  name: 'Colissimo Home 0.25-0.5kg',
  minWeight: 0.250,
  maxWeight: 0.500,
  FR: 8.83
}, {
  id: 367,
  name: 'Colissimo Home 0.5-0.75kg',
  minWeight: 0.500,
  maxWeight: 0.750,
  FR: 8.83
}, {
  id: 364,
  name: 'Colissimo Home 0.75-1kg',
  minWeight: 0.750,
  maxWeight: 1,
  FR: 8.83
}, {
  id: 1066,
  name: 'Colissimo Home 1-2kg',
  minWeight: 1,
  maxWeight: 2,
  FR: 12.01
}, {
  id: 1067,
  name: 'Colissimo Home 2-3kg',
  minWeight: 2,
  maxWeight: 3,
  FR: 13.18
}, {
  id: 1068,
  name: 'Colissimo Home 3-4kg',
  minWeight: 3,
  maxWeight: 4,
  FR: 14.38
}, {
  id: 1069,
  name: 'Colissimo Home 4-5kg',
  minWeight: 4,
  maxWeight: 5,
  FR: 15.53
}, {
  id: 1070,
  name: 'Colissimo Home 5-6kg',
  minWeight: 5,
  maxWeight: 6,
  FR: 15.53
}, {
  id: 1071,
  name: 'Colissimo Home 6-7kg',
  minWeight: 6,
  maxWeight: 7,
  FR: 15.53
}, {
  id: 1072,
  name: 'Colissimo Home 7-8kg',
  minWeight: 7,
  maxWeight: 8,
  FR: 15.53
}, {
  id: 1073,
  name: 'Colissimo Home 8-9kg',
  minWeight: 8,
  maxWeight: 9,
  FR: 17.70
}, {
  id: 1074,
  name: 'Colissimo Home 9-10kg',
  minWeight: 9,
  maxWeight: 10,
  FR: 18.80
}, {
  id: 1075,
  name: 'Colissimo Home 10-11kg',
  minWeight: 10,
  maxWeight: 11,
  FR: 19.90
}, {
  id: 1076,
  name: 'Colissimo Home 11-12kg',
  minWeight: 11,
  maxWeight: 12,
  FR: 20.60
}, {
  id: 1077,
  name: 'Colissimo Home 12-13kg',
  minWeight: 12,
  maxWeight: 13,
  FR: 20.60
}, {
  id: 1078,
  name: 'Colissimo Home 13-14kg',
  minWeight: 13,
  maxWeight: 14,
  FR: 20.60
}, {
  id: 1079,
  name: 'Colissimo Home 14-15kg',
  minWeight: 14,
  maxWeight: 15,
  FR: 20.60
}, {
  id: 1080,
  name: 'Colissimo Home 15-16kg',
  minWeight: 15,
  maxWeight: 16,
  FR: 20.60
}, {
  id: 1081,
  name: 'Colissimo Home 16-17kg',
  minWeight: 16,
  maxWeight: 17,
  FR: 20.60
}, {
  id: 1082,
  name: 'Colissimo Home 17-18kg',
  minWeight: 17,
  maxWeight: 18,
  FR: 20.60
}, {
  id: 1083,
  name: 'Colissimo Home 18-19kg',
  minWeight: 18,
  maxWeight: 19,
  FR: 20.60
}, {
  id: 1084,
  name: 'Colissimo Home 19-20kg',
  minWeight: 19,
  maxWeight: 20,
  FR: 20.60
}, {
  id: 1085,
  name: 'Colissimo Home 20-21kg',
  minWeight: 20,
  maxWeight: 21,
  FR: 20.60
}, {
  id: 1086,
  name: 'Colissimo Home 21-22kg',
  minWeight: 21,
  maxWeight: 22,
  FR: 20.60
}, {
  id: 1087,
  name: 'Colissimo Home 22-23kg',
  minWeight: 22,
  maxWeight: 23,
  FR: 20.60
}, {
  id: 1088,
  name: 'Colissimo Home 23-24kg',
  minWeight: 23,
  maxWeight: 24,
  FR: 20.60
}, {
  id: 1089,
  name: 'Colissimo Home 24-25kg',
  minWeight: 24,
  maxWeight: 25,
  FR: 20.60
}, {
  id: 1090,
  name: 'Colissimo Home 25-26kg',
  minWeight: 25,
  maxWeight: 26,
  FR: 20.60
}, {
  id: 1091,
  name: 'Colissimo Home 26-27kg',
  minWeight: 26,
  maxWeight: 27,
  FR: 20.60
}, {
  id: 1092,
  name: 'Colissimo Home 27-28kg',
  minWeight: 27,
  maxWeight: 28,
  FR: 20.60
}, {
  id: 1093,
  name: 'Colissimo Home 28-29kg',
  minWeight: 28,
  maxWeight: 29,
  FR: 20.60
}, {
  id: 1094,
  name: 'Colissimo Home 29-30kg',
  minWeight: 29,
  maxWeight: 30,
  FR: 20.60
}];
var mondialRelayShippingMethods = exports.mondialRelayShippingMethods = [{
  id: 28035,
  name: 'Mondial Relay Point Relais L 0-0.25kg',
  minWeight: 0.015,
  maxWeight: 0.250,
  FR: 3.05
}, {
  id: 28036,
  name: 'Mondial Relay Point Relais L 0.25-0.5kg',
  minWeight: 0.250,
  maxWeight: 0.500,
  FR: 3.49
}, {
  id: 28037,
  name: 'Mondial Relay Point Relais L 0.5-1kg',
  minWeight: 0.500,
  maxWeight: 1,
  FR: 3.93
}, {
  id: 28038,
  name: 'Mondial Relay Point Relais L 1-2kg',
  minWeight: 1,
  maxWeight: 2,
  FR: 4.80
}, {
  id: 28039,
  name: 'Mondial Relay Point Relais L 2-3kg',
  minWeight: 2,
  maxWeight: 3,
  FR: 5.68
}, {
  id: 28040,
  name: 'Mondial Relay Point Relais L 3-5kg',
  minWeight: 3,
  maxWeight: 5,
  FR: 8.73
}, {
  id: 28041,
  name: 'Mondial Relay Point Relais L 5-7kg',
  minWeight: 5,
  maxWeight: 7,
  FR: 10.05
}, {
  id: 28042,
  name: 'Mondial Relay Point Relais L 7-10kg',
  minWeight: 7,
  maxWeight: 10,
  FR: 11.36
}, {
  id: 28043,
  name: 'Mondial Relay Point Relais L 10-15kg',
  minWeight: 10,
  maxWeight: 15,
  FR: 16.60
}, {
  id: 28044,
  name: 'Mondial Relay Point Relais L 15-20kg',
  minWeight: 15,
  maxWeight: 20,
  FR: 18.75
}, {
  id: 28045,
  name: 'Mondial Relay Point Relais L 20-25kg',
  minWeight: 20,
  maxWeight: 25,
  FR: 22.32
}, {
  id: 28046,
  name: 'Mondial Relay Point Relais L 25-30kg',
  minWeight: 25,
  maxWeight: 30,
  FR: 26.79
}];

// export const mondialRelayShippingMethodsEU = [
//   {
//     id: 1685,
//     name: 'Mondial Relay Point Relais International 0-0.5kg',
//     minWeight: '0.015',
//     maxWeight: '0.501',
//     BE: 3.75,
//     LU: 3.75,
//     NL: 4.58,
//     PT: 5.61,
//     ES: 5.61,
//   },
//   {
//     id: 1689,
//     name: 'Mondial Relay Point Relais International 0.5-1kg',
//     minWeight: '0.501',
//     maxWeight: '1.001',
//     BE: 4.41,
//     LU: 4.41,
//     NL: 4.98,
//     PT: 5.94,
//     ES: 5.94,
//   },
//   {
//     id: 1692,
//     name: 'Mondial Relay Point Relais International 1-2kg',
//     minWeight: '1.001',
//     maxWeight: '2.001',
//     BE: 4.98,
//     LU: 4.98,
//     NL: 5.73,
//     PT: 6.68,
//     ES: 6.68,
//   },
//   {
//     id: 1693,
//     name: 'Mondial Relay Point Relais International 2-3kg',
//     minWeight: '2.001',
//     maxWeight: '3.001',
//     BE: 5.73,
//     LU: 5.73,
//     NL: 6.47,
//     PT: 7.43,
//     ES: 7.43,
//   },
//   {
//     id: 1690,
//     name: 'Mondial Relay Point Relais International 3-5kg',
//     minWeight: '3.001',
//     maxWeight: '5.001',
//     BE: 6.72,
//     LU: 6.72,
//     NL: 7.95,
//     PT: 8.91,
//     ES: 8.91,
//   },
//   {
//     id: 1686,
//     name: 'Mondial Relay Point Relais International 5-7kg',
//     minWeight: '5.001',
//     maxWeight: '7.001',
//     BE: 8.79,
//     LU: 8.87,
//     NL: 9.44,
//     PT: 10.4,
//     ES: 10.4,
//   },
//   {
//     id: 1691,
//     name: 'Mondial Relay Point Relais International 7-10kg',
//     minWeight: '7.001',
//     maxWeight: '10.001',
//     BE: 10.72,
//     LU: 10.72,
//     NL: 11.67,
//     PT: 12.62,
//     ES: 12.62,
//   },
//   {
//     id: 1688,
//     name: 'Mondial Relay Point Relais International 10-15kg',
//     minWeight: '10.001',
//     maxWeight: '15.001',
//     BE: 12.95,
//     LU: 12.95,
//     NL: 15.38,
//     PT: 16.34,
//     ES: 16.34,
//   },
//   {
//     id: 1687,
//     name: 'Mondial Relay Point Relais International 15-20kg',
//     minWeight: '15.001',
//     maxWeight: '20.001',
//     BE: 16.25,
//     LU: 16.25,
//     NL: 22.8,
//     PT: 23.76,
//     ES: 23.76,
//   },
//   {
//     id: 5024,
//     name: 'Mondial Relay Point Relais International 20-25kg',
//     minWeight: '20.001',
//     maxWeight: '25.001',
//     BE: 16.91,
//     LU: 16.91,
//     NL: 23.72,
//     PT: 24.71,
//     ES: 24.71,
//   },
//   {
//     id: 5025,
//     name: 'Mondial Relay Point Relais International 25-30kg',
//     minWeight: '25.001',
//     maxWeight: '30.001',
//     BE: 16.91,
//     LU: 16.91,
//     NL: 23.72,
//     PT: 24.71,
//     ES: 24.71,
//   },
// ];